import { Component, HostListener, OnInit } from '@angular/core';
import { ActionItemTypeModel } from 'src/Models/ActionItemTypeModel';
import { ActionItemService } from 'src/Services/actionitem.service';
import { CheckAuth } from 'src/Services/utility.service';
import { FilterModel } from 'src/Models/filterModel';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-action-item-type',
  templateUrl: './action-item-type.component.html',
  styleUrls: ['./action-item-type.component.css']
})
export class ActionItemTypeComponent implements OnInit {
  tokenKey: string = '';
  loginuserID: number;

  actionTypeList: ActionItemTypeModel[];
  actionTypeListExport: ActionItemTypeModel[];
  filterParameter = new FilterModel();
  totalRecordCount: number = -1;

  upDowNameCSS: string = '';
  upDowSortCSS: string = '';
  upDowColorCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowModifiedDateCSS: string = '';
  isAscending: boolean;
  SelectedTool: string;

  isloading: boolean = false;
  deleteId: number = 0;
  openMenuIndex: number = -1;
  currentPage:number=1;

  constructor(private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private readonly router: Router,
    private readonly actionItemService: ActionItemService,
    private readonly checkAuth: CheckAuth,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();

    this.currentPage = 1;
    this.filterParameter.pageNumber = '1';
    this.filterParameter.pageSize = '10';
    this.filterParameter.whereCondition = '';
    this.filterParameter.orderBy = 'SortOrder';
    this.titleService.setTitle('Categories');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.GetActionTypesByPages();
  }

  GetActionTypesByPages() {
    this.isloading = true;
    this.actionTypeList = [];
    this.filterParameter.IsExport = false;
    this.actionItemService.GetActionTypesByPages(this.tokenKey, this.filterParameter).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          this.actionTypeList = data['actionTypesList'];
          if (this.actionTypeList != null) {
            if (this.actionTypeList.length > 0) {
              this.totalRecordCount = data['actionTypesList'][0]['totalRecordCount'];
            }
            else {
              this.totalRecordCount = 0;
            }
          }
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterParameter.pageNumber = parseInt($event.page).toString();
    this.GetActionTypesByPages();
  }

  sort(sortBy: any) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.filterParameter.orderBy = sortBy + ' DESC';

      if (sortBy === "typeName") {
        this.upDowNameCSS = 'fa fa-arrow-down';
        this.upDowColorCSS = '';
        this.upDowSortCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedDateCSS = '';
      }
      else if (sortBy === "colorCode") {
        this.upDowNameCSS = '';
        this.upDowColorCSS = 'fa fa-arrow-down';
        this.upDowSortCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedDateCSS = '';
      }
      else if (sortBy === "createdDate") {
        this.upDowNameCSS = '';
        this.upDowColorCSS = '';
        this.upDowSortCSS = '';
        this.upDowCreatedDateCSS = 'fa fa-arrow-down';
        this.upDowModifiedDateCSS = '';
      }
      else if (sortBy === "modifiedDate") {
        this.upDowNameCSS = '';
        this.upDowColorCSS = '';
        this.upDowSortCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "sortOrder") {
        this.upDowNameCSS = '';
        this.upDowColorCSS = '';
        this.upDowSortCSS = 'fa fa-arrow-down';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedDateCSS = '';
      }
    }
    else {
      this.isAscending = false;
      this.filterParameter.orderBy = sortBy;

      if (sortBy === "typeName") {
        this.upDowNameCSS = 'fa fa-arrow-up';
        this.upDowColorCSS = '';
        this.upDowSortCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedDateCSS = '';
      }
      else if (sortBy === "colorCode") {
        this.upDowNameCSS = '';
        this.upDowColorCSS = 'fa fa-arrow-up';
        this.upDowSortCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedDateCSS = '';
      }
      else if (sortBy === "createdDate") {
        this.upDowNameCSS = '';
        this.upDowColorCSS = '';
        this.upDowSortCSS = '';
        this.upDowCreatedDateCSS = 'fa fa-arrow-up';
        this.upDowModifiedDateCSS = '';
      }
      else if (sortBy === "modifiedDate") {
        this.upDowNameCSS = '';
        this.upDowColorCSS = '';
        this.upDowSortCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "sortOrder") {
        this.upDowNameCSS = '';
        this.upDowColorCSS = '';
        this.upDowSortCSS = 'fa fa-arrow-up';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedDateCSS = '';
      }
    }
    this.currentPage = 1;
    this.filterParameter.pageNumber = '1';
    this.GetActionTypesByPages();
  }

  editActionItemType(actionItemTypeId: any) {
    this.router.navigate(['admin/trac-it/category/manage/' + actionItemTypeId]);
  }

  setDeletActionItem(actionItemTypeId: any) {
    this.deleteId = actionItemTypeId;
  }

  deletActionItemType(actionItemTypeId: any) {
    this.actionItemService.DeleteActionTypes(this.tokenKey, actionItemTypeId).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.showMessage('Record deleted successfully', 'Sucess', 'success');
          this.GetActionTypesByPages();
        }
        else
          this.showMessage(data['status'] + '-' + data['message'], 'Error', 'error');
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportCategories() {
    this.isloading = true;
    this.actionTypeListExport = [];
    this.filterParameter.IsExport = true;
    this.actionItemService.GetActionTypesByPages(this.tokenKey, this.filterParameter).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.actionTypeListExport = data['actionTypesList'];
          if (this.actionTypeListExport != null) {
            if (this.actionTypeListExport.length > 0) {
              setTimeout(() => {
                this.DownloadCategories();
                this.isloading = false;
              }, 2000);
            }
            else {
              this.isloading = false;
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  DownloadCategories() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportTracItCategories';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportTracItCategories.xls");
  }

}
